export default __webpack_public_path__ + "static/media/Set4_3-min2.cfb70354.png";